import { ChildDropDownItem } from '../../../fields/child-dropdown-item.model';
import { Range } from '../../entities/range.model';
import { Table } from '../../entities/table.model';


export class ChildDropDownItemsTable extends Table<{ [key: string]: ChildDropDownItem[]; }> {
  constructor(
    private permanentColumnsCount: number,
    range: Range) {
    super(range, false, {});
  }

  add(fieldId: number, itemId: string, childItems: ChildDropDownItem[]): boolean {
    if (!this.exists(fieldId, itemId)) {
      const columnDiff = childItems.length - (this.range.columnCount - this.permanentColumnsCount);

      if (columnDiff > 0) {
        this.range.columnCount += columnDiff;
      }

      if (this.containsData) {
        this.range.rowCount++;
      } else {
        this.containsData = true;
      }

      this.cache[this.getKey(fieldId, itemId)] = childItems;
      return true;
    }

    return false;
  }

  remove(fieldId: number, itemId: string): boolean {
    if (this.exists(fieldId, itemId)) {
      delete this.cache[this.getKey(fieldId, itemId)];

      if (this.range.rowCount == 2 /* header + one row */) {
        this.containsData = false;
      } else {
        this.range.rowCount--;
      }

      return true;
    }

    return false;
  }

  getChildItems(fieldId: number, itemId: string): ChildDropDownItem[] {
    const childItems = this.cache[this.getKey(fieldId, itemId)];
    return childItems ? [...childItems] : undefined;
  }

  getRowPosition(fieldId: number, itemId: string): number {
    if (this.exists(fieldId, itemId)) {
      return Object
        .keys(this.cache)
        .indexOf(this.getKey(fieldId, itemId));
    }

    return -1;
  }

  exists(fieldId: number, itemId: string): boolean {
    return this.cache.hasOwnProperty(this.getKey(fieldId, itemId));
  }

  private getKey(fieldId: number, itemId: string): string {
    return fieldId + '|' + itemId;
  }
};